import { createAction } from 'redux-promise-middleware-actions';

export const reportAppcuesEventAction = createAction('REPORT_APPCUES_EVENT', (name, event) => ({ name, event }));
